
import Freegames from "./freegames";
import Barrel from "./rx_barrel";
import { REQUEST_TYPE } from "./network/net";
import { TYPE, canGo, cannotGo, canOnlyGo } from "./network/network_api";
import Stream from "./frp/stream";
import SETTINGS from 'settings'
import { get_prop } from 'utils'

/* We have our own (client-side) intermediate states within server-wise FINISH state:
* server: FINISH                                            ->                                                  FINAL
* client: FINISH  ->  table(F1)  ->  enable "finish" btn (F_2)  ->  click "finish"(F_3) -> risk/collect(F_4) -> FINAL
*/
export const FINISHING_STATES =
{
    NONE : 1,
    SHOWING_TABLE : 2,
    FINISH_INVITATION : 3,
    ENDING : 3.5,
    RISK_INVITATION : 4,
};

export default function(
    parent,
    slotScene,
    spec
)
{
    const space = parent.child( "slot" );
    
    const $state = parent.s( "state" );
    const $request = parent.s( "request" );
    const $pending = parent.s( "pending" );
    
    const $displayingWin = space.s( "displayingWin", false );
    const $animating = space.s( "animating", false );
    
    //REGULAR game:
    const barrel = Barrel(
        space,
        $state.filter( state => state.type == TYPE.REGULAR || state.type == TYPE.FREEGAME ),
        SETTINGS.slot_max_rotation,
    );
    const $initiate = barrel.s( "initiate" );
    const $spinStartSlot = parent.s( "slot:spinStart" );
    const $spinStartFreegames = parent.s( "freegames:spinStart" );
    const $start = parent.s( 'barrel:start' )
    barrel.s( "start" )
        .withLatestFrom( $state, ( start, state ) => ({ start, state }) )
        .subscribe( ({ start, state }) => {
            let isFreegames = false;
            //freegames' $spinStart must be called BEFORE barrel.$start:
            if (
                //within freegames:
                state.type == TYPE.FREESPIN
                ||
                //when initiating first freespin:
                ( ! start && canOnlyGo( TYPE.FREESPIN, state ) )
            )
            {
                isFreegames = true;
                $spinStartFreegames.next( {
                    freespinNumber : state.server.freespinNumber + ( start ? 0 : 1 ),
                    freespinsCount : state.server.freespinsCount - ( start ? state.server.freespinsIncrease : 0 ),
                    math : state.state.stage.math,
                    server : state.server,
                    restore : ( start ? true : false )
                } );
            }
            else
            {
                $spinStartSlot.next( state );
            }
            
            $start.next( {
                isFreegames,
                previousSymbols : state.state.stage.math ? state.state.stage.math.symbols : [],
                newSymbols : start ? (start.state.stage.math ? start.state.stage.math.symbols : []) : undefined,
                server : state.server
            } );
        } );
    barrel.s( "stop" ).subscribe( parent.s( 'barrel:end' ) )
    $state
        .filter( state => state.type != TYPE.REGULAR && state.type != TYPE.FREESPIN )
        .map( state => get_prop( state, [ 'server', 'math', 'symbols' ] ) )
        //now game has FINISH states for bonuses as well (no reels visible at the time):
        .filter( symbols => symbols )
        .subscribe( parent.s( 'barrel:static' ) )
    
    // ui_view -> barrel:
    parent.s( "ui:stop" ).subscribe( barrel.s( "interruptUser" ) );
    parent.s( "ui:spin" ).subscribe( $initiate );
    parent.s( 'barrel:click' ).to( parent.s( "ui:barrelClick" ) );
    
    //regular spin:
    barrel.s( "request" )
        .withLatestFrom( $state, ( r, state ) => state )
        .filter( state => cannotGo( TYPE.FREEGAME, state.state ) )
        .withLatestFrom( parent.s( "ui:betValue" ), ( state, betValue ) => ({
            lines : betValue.lines,
            multiplier : betValue.multiplier,
            type : REQUEST_TYPE.SPIN,
        }) )
        .subscribe( $request );
    //freespin:
    barrel.s( "request" )
        .withLatestFrom( $state, ( r, state ) => state )
        .filter( state => canGo( TYPE.FREEGAME, state.state ) )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .subscribe( $request );
    
    //slot scene:
    parent.s( "ui:betValue" )
        .take( 1 )
        .subscribe( parent.s( "slot:initial" ) );
    parent.s( "ui:linesValue" )
        .distinctUntilChanged( _.isEqual )
        .pairwise()
        .subscribe( parent.s( "slot:linesChange" ) );
    parent.s( "ui:multiplierValue" )
        .distinctUntilChanged( _.isEqual )
        .pairwise()
        .subscribe( parent.s( "slot:multiplierChange" ) );
    parent.s( "ui:resultBet" )
        .map( c => c.bet )
        .subscribe( parent.s( "slot:bet" ) );
    /*temp:*/$state
        .filter( state => state.type == TYPE.REGULAR || state.type == TYPE.FREESPIN )
        .on( state => slotScene && slotScene.dataDidReceived && slotScene.dataDidReceived( state.state.stage.math ) )
    
    const $isFreegames = $state.map( state => state.type == TYPE.FREEGAME );
    const $reelStopSlot = parent.s( "slot:reelStop" );
    const $reelStopFreegames = parent.s( "freegames:reelStop" );
    parent.s( 'barrel:reelStop' )
        .withLatestFrom( $isFreegames, ( stop, isFreegames ) => ({ stop, isFreegames }) )
        .subscribe( ({ stop, isFreegames }) => {
            if ( isFreegames ) $reelStopFreegames.next( stop );
            else $reelStopSlot.next( stop );
        } );
    const $spinStopFreegames = parent.s( "freegames:spinStop" );
    const $spinStopSlot = parent.s( "slot:spinStop" );
    parent.s( 'barrel:stop' )
        .withLatestFrom( $isFreegames, ( stop, isFreegames ) => ({ stop, isFreegames }) )
        .subscribe( ({ stop, isFreegames }) => {
            if ( isFreegames ) $spinStopFreegames.next( stop );
            else $spinStopSlot.next( stop );
        } );
    
    Freegames(
        $state,
        parent
    );
    const $beginningFeature = parent.s( "ui:beginningFeature", false );
    parent.s( "ui:start" )
        .withLatestFrom( $state, ( i, state ) => state )
        .on( state => {
            let leaf
            if ( canGo( TYPE.FREEGAME, state ) ) leaf = 'freegames'
            if ( canGo( TYPE.BONUS_1, state ) ) leaf = 'bonus'
            if ( canGo( TYPE.BONUS_2, state ) ) leaf = 'superbonus'
            if ( leaf )
            {
                $beginningFeature.next( true );
                parent.child( leaf ).s( "begin" ).next( state )
            }
        } );
    const $interruptWinShow = parent.s( "slot:interruptWinShow" );
    parent.s( "freegames:beginComplete" )
        //interrupt regular spin win display:
        .withLatestFrom( $displayingWin, ( p, d ) => d )
        .subscribe( d =>
        {
            $beginningFeature.next( false );
            if ( d )
            {
                $displayingWin.next( false );
                $interruptWinShow.next();
            }
            $initiate.next();
        } );
    parent.s( "bonus:beginComplete" )
        .with( $displayingWin, ( _, d ) => d )
        .with( $state, ( d, state ) => ({ d, state }) )
        .on( ({ d, state }) => {
            $beginningFeature.next( false );
            if ( d )
            {
                $displayingWin.next( false );
                $interruptWinShow.next();
            }
            parent.s( "bonus:showResult" ).next( state );
            parent.s( "ui:isBonus" ).next( true );
        } );
    
    const $rotating = space.s( "rotating", false );
    barrel.s( "start" )
        .map( () => true )
        .merge( parent.s( 'barrel:stop' ).map( () => false ) )
        .subscribe( $rotating );
    
    //spin -> ...
    const $barrelStop = parent.s( 'barrel:stop' ).withLatestFrom( $state, ( stop, state ) => state );
    $barrelStop.map( () => undefined ).to( parent.s( "slot:forbidStop" ) );
    $barrelStop.subscribe( space.s( "barrelStop" ) );
    //automatically finish round when no win (can't go risk):
    $barrelStop
        .with( parent.s( 'pending' ), ( state, pending ) => ({ state, pending }) )
        .filter( ({ pending }) => pending == undefined )
        .map( ({ state }) => state )
        .filter( state =>
            state.type == TYPE.REGULAR
            &&
            state.state.stage.win <= 0
            &&
            canOnlyGo( TYPE.FINAL, state.state )
        )
        .map( () => ({ type : REQUEST_TYPE.TAKE_WIN }) )
        .subscribe( $request );
    //stop button:
    $rotating
        .combineLatest(
            $state,
            ( rotating, state ) =>
            (
                rotating
                ||
                state.type == TYPE.FREESPIN
            )
            &&
            state.type != TYPE.PRECURSOR
            &&
            state.type != TYPE.JACKPOT
         )
        .subscribe( parent.s( "ui:mayStop" ) );

    //попросили реализовать возможность останавливать барабан даже когда данные ещё не готовы (чтобы он мог остановиться в будущем как только будут готовы данные):
    /*barrel.s( "hasData" )  
        .combineLatest( $rotating, ( hasData, rotating ) => hasData && rotating )*/
    $rotating
        .any( parent.s( "slot:forbidStop" ), ( can, forbid ) => can && ! forbid )
        .to( parent.s( "ui:canInterruptBarrel" ) );
    
    //display winnings:
    const $winningRegularStop = $barrelStop
        .filter( state =>
            state.type == TYPE.REGULAR
            &&
            //people say there can be spins without winnings, but leading to bonus:
            ( state.state.stage.win > 0 || cannotGo( TYPE.FINAL, state.state ) )
        );
    $winningRegularStop.subscribe( space.s( "winningRegularStop" ) );
    const $showWinSlot = parent.s( "slot:showWin" );
    $winningRegularStop
        .filter( state => canOnlyGo( TYPE.FINAL, state ) )
        .map( state =>
            ({
                bet : state.server.betValue,
                math : state.state.stage.math,
                win : state.state.stage.win,
            })
        )
        .subscribe( p =>
        {
            $displayingWin.next( true );
            $showWinSlot.next( p );
        } );
    const $showPreFeatureWinSlot = parent.s( "slot:showPreFeatureWin" );
    $winningRegularStop
        .filter( state => cannotGo( TYPE.FINAL, state.state ) )
        .withLatestFrom( parent.s( "ui:betValue" ), ( state, bet ) => ({
            math : state.state.stage.math,
            bet,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            bonus : canGo( TYPE.BONUS_1, state ),
            freespinsCount : state.server.freespinsCount
        }) )
        .subscribe( p => {
            $displayingWin.next( true );
            $showPreFeatureWinSlot.next( p );
        } );
    parent.s( "slot:showWinComplete" ).map( () => false ).to( $displayingWin );
    
    $pending
        .withLatestFrom( $displayingWin, ( p, d ) => d )
        .filter( d => d )
        .subscribe( () =>
        {
            $displayingWin.next( false );
            $interruptWinShow.next();
        } );
    
    //display freegame winnings:
    const $freegamesStop = $barrelStop.filter( state => state.type == TYPE.FREEGAME );
    
    //freespin with no winning or win display completed:
    const $freespinComplete = space.s( "freespinComplete" );
    $freespinComplete.subscribe( state =>
    {
        if ( canGo( TYPE.FREESPIN, state ) )
        {
            $initiate.next();
        }
        else if ( canGo( TYPE.FINISH, state ) )
        {
            $request.next( { type : REQUEST_TYPE.FINISH } );
        }
        else
        {
            //TODO: bonus
        }
    } );
    
    //freespin with nothing:
    $freegamesStop
        .filter( state =>
            state.state.stage.win <= 0 &&
            (
                canOnlyGo( TYPE.FREESPIN, state )
                ||
                canOnlyGo( TYPE.FINISH, state )
            )
        )
        .withLatestFrom( parent.s( "ui:betValue" ), ( state, bet ) => ({ state, bet }) )
        .map( ({ state, bet }) => ({
            math : state.state.stage.math,
            bet: bet,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            freespinsCount : state.server.freespinsCount,
            state: state,
            server : state.server
        }) )
        .subscribe( parent.s( "freegames:noFreeWin" ) );
    const $showWinFreegames = parent.s( "freegames:showWin" );
    //freespin with just normal winnings (no bonus enter):
    $freegamesStop
        .filter( state =>
            state.state.stage.win > 0 &&
            (
                canOnlyGo( TYPE.FREESPIN, state )
                ||
                canOnlyGo( TYPE.FINISH, state )
            )
        )
        .withLatestFrom( parent.s( "ui:betValue" ), ( state, bet ) => ({ state, bet }) )
        .subscribe( ({ state, bet }) =>
        {
            $animating.next( true );
            const p = {
                math : state.state.stage.math,
                bet,
                freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
                win : state.state.stage.win,
                freespinsCount : state.server.freespinsCount,
                state
            };
            $showWinFreegames.next( p );
        } );
    const $showPreFeatureWinFreegames = parent.s( "freegames:showPreFeatureWin" );
    //freespin with bonus enter:
    $freegamesStop
        .filter( state =>
            cannotGo( TYPE.FINISH, state ) &&
            cannotGo( TYPE.FREESPIN, state )
        )
        .withLatestFrom( parent.s( "ui:betValue" ), ( state, betValue ) => ({
            math : state.state.stage.math,
            bet : betValue,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            freespinsCount : state.server.freespinsCount
        }) )
        .subscribe( p =>
        {
            $animating.next( true );
            $showPreFeatureWinFreegames.next( p );
        } );
    //proceed freegames after win display completes:
    parent.s( "freegames:showComplete" )
        .withLatestFrom( $state, ( c, state ) => state )
        .subscribe( state =>
        {
            $animating.next( false );
            $freespinComplete.next( state );
        } );
    parent.s( "freegames:endingComplete" )
        .map( () => false )
        .subscribe( $animating );
    
    const $endingFreespins = parent.s( "freegames:ending" );
    const $endingBonus = parent.s( "bonus:ending" );
    const $endingSuperbonus = parent.s( "superbonus:ending" );
    //display freegames resulting table:
    const $finishing = parent.s( "ui:finishing" );
    $state.on( state =>
    {
        if (
            state.type != TYPE.FINISH
            ||
            //some games has "FEATURE_END" state between bonus and freegames:
            cannotGo( TYPE.FINAL, state )
        )
        {
            $finishing.next( FINISHING_STATES.NONE );
            return;
        }
        
        $finishing.next( FINISHING_STATES.SHOWING_TABLE );
        
        const d = {
            math :  state.state.stage.math,
            bet : {
                lines : state.state.line_count,
                multiplier : state.state.multiplier,
            },
            totalWin: state.state.open_win
        };
        
        switch ( state.state.stage.math.featureType )
        {
            case TYPE.BONUS_1: $endingBonus.next( d ); break;
            case TYPE.BONUS_2: $endingSuperbonus.next( d ); break;
            default: $endingFreespins.next( d );
        }
    } )
    //can't use merge() operator here because it waits for all parents before button can be activated but games use "endingComplete"->"ui:finish" button redirection to skip this stage:
    /*Stream.merge(
        leaves.freegames.space.s( "endingComplete" ),
        leaves.bonus.space.s( "endingComplete" ),
        leaves.superbonus.space.s( "endingComplete" )
    )
    .map( () => FINISHING_STATES.FINISH_INVITATION )
    .to( $finishing );*/
    parent.s( "freegames:endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    parent.s( "bonus:endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    parent.s( "superbonus:endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    
    const $endFreegames = parent.s( "freegames:end" );
    const $endBonus = parent.s( "bonus:end" );
    const $endSuperbonus = parent.s( "superbonus:end" );
    //finish button:
    parent.s( "ui:finish" )
        .withLatestFrom( $state, ( f, state ) => state.state.stage.math )
        .on( math =>
        {
            
            switch ( math.featureType )
            {
                case TYPE.BONUS_1:
                    $finishing.next( FINISHING_STATES.RISK_INVITATION );
                    $endBonus.next( math );
                    break;
                
                case TYPE.BONUS_2:
                    $finishing.next( FINISHING_STATES.RISK_INVITATION );
                    $endSuperbonus.next( math );
                    break;
                
                default:
                    $finishing.next( FINISHING_STATES.ENDING );
                    $endFreegames.next( math );
                    break;
            }
        } );
    parent.s( "freegames:tableHidden" )
        .map( () => FINISHING_STATES.RISK_INVITATION )
        .to( $finishing );

    $finishing
        .filter((f_state) => f_state == FINISHING_STATES.RISK_INVITATION)
        .map(() => spec.risks.length > 0)
        .to( parent.s( "slot:playingClockSound" ));

    space.s( "ui:collect" ).map(() => false).to( parent.s( "slot:playingClockSound" ));
    space.s( "ui:gamble" ).map(() => false).to( parent.s( "slot:playingClockSound" ));
    
    return {
        space,
        barrel,
    };
}




// WEBPACK FOOTER //
// ./src/library/slot.es6